import { SchemaModule, ModuleValue, ModuleHasProms } from './module';
import { FormComponent } from '../form.component';
import { DATE_DAY } from '../constants';

export class ModuleValueUniversal extends ModuleValue implements ModuleHasProms {
  proms?: {
    id?: string;
    message?: string;
    follow_up_7?: boolean;
    follow_up_30_and_180?: boolean;
    patient_name?: string;
    patient_phone?: string;
  };

  patient_ethnicity?: string;
  date_of_surgery: string;
  asa?: string;
  pre_existing_comorbidities?: string;
  primary_surgeon?: string;
  main_procedure: string;
}

export class SchemaModuleUniversal<T extends ModuleValueUniversal = ModuleValueUniversal> extends SchemaModule<T> {

  hook( form: FormComponent ) {
    super.hook( form );
  }

  fieldHandlerDischargeDate<K extends keyof T>( lengthOfStayProperty: K ) {
    return ( dischargeDateString: string, dateOfSurgeryString: string ) => {
      const dateOfSurgery = new Date( dateOfSurgeryString );
      const dischargeDate = new Date( dischargeDateString );
      let lengthOfStay = Math.ceil( ( dischargeDate.valueOf() - dateOfSurgery.valueOf() ) / DATE_DAY );
      if ( isNaN( lengthOfStay.valueOf() ) || lengthOfStay < 0 ) {
        lengthOfStay = null;
      }
      this.updateValue( lengthOfStayProperty, lengthOfStay as any );
    };
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-universal.ts